import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-950 text-foreground-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-line text-background-50 w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="font-heading font-bold text-foreground-50 leading-tight">
                AllChinaBuy
                <span className="block text-xs font-medium text-foreground-300">Spreadsheet</span>
              </span>
            </div>
            <p className="text-sm text-foreground-300 max-w-md leading-relaxed">{t('footer.about')}</p>
            <p className="mt-4 text-xs text-foreground-400 max-w-md leading-relaxed">{t('footer.disclaimer')}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">
              <Link to="/" className="cursor-pointer">{t('footer.linksTitle')}</Link>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/allchinabuy-spreadsheet" className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
                  {t('nav.guide')}
                </Link>
              </li>
              <li>
                <a href="#categories" className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
                  {t('nav.categories')}
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
                  {t('nav.faq')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">{t('footer.categoriesTitle')}</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((c) => (
                <li key={c.key}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer"
                  >
                    {t(`cat.${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-foreground-900 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            © {new Date().getFullYear()} AllChinaBuy Spreadsheet. {t('footer.rights')}
          </p>
          <p className="text-xs text-foreground-400">allchinabuyspread.quest</p>
        </div>
      </div>
    </footer>
  );
}